"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloudObject = exports.CloudObjectNotLoaded = exports.CloudObjectFormatError = exports.CloudObjectError = void 0;
const MapSerializer_1 = require("./MapSerializer");
const MagickRecord_1 = require("./MagickRecord");
const unicrypto_1 = require("unicrypto");
var ownKeys = Reflect.ownKeys;
class CloudObjectError extends Error {
}
exports.CloudObjectError = CloudObjectError;
class CloudObjectFormatError extends CloudObjectError {
}
exports.CloudObjectFormatError = CloudObjectFormatError;
class CloudObjectNotLoaded extends CloudObjectError {
}
exports.CloudObjectNotLoaded = CloudObjectNotLoaded;
class CloudObject {
    constructor(params = {
        labels: {
            sb1: { encrypted: true },
            ssb1: { encrypted: true, signed: true },
            sr1: { signed: true }
        },
        strategy: "error"
    }) {
        this.params = params;
    }
    async loadFrom(element, service) {
        this._service = service;
        if (!element.head)
            throw new CloudObjectFormatError("head is empty");
        const record = await MagickRecord_1.MagickRecord.unpack(element.head, ...ownKeys(this.params.labels));
        const ll = this.params.labels[record.label];
        this._service = service;
        if (ll.encrypted && ll.signed) {
            this._signedRecord = await unicrypto_1.SignedRecord.unpack(record.payload);
            this._sharedBox = await MapSerializer_1.MapSerializer.deserialize(this._signedRecord.payload);
        }
        else if (ll.encrypted && !ll.signed) {
            this._signedRecord = undefined;
            this._sharedBox = record.payload;
        }
        else if (!ll.encrypted && ll.signed) {
            this._signedRecord = await unicrypto_1.SignedRecord.unpack(record.payload);
            this._sharedBox = undefined;
            this._data = await MapSerializer_1.MapSerializer.deserializeAny(this._signedRecord.payload);
        }
        if (!this._data) {
            if (!this._sharedBox)
                throw new CloudObjectFormatError(`no data found in ${this._element}`);
            await this._sharedBox.unlockWithRing(await service.mainRing);
            this._data = await MapSerializer_1.MapSerializer.anyFromBoss(await this._sharedBox.payloadPromise);
        }
        // TODO: store in local storage!
        return this;
    }
    get loaded() { return !!this._sharedBox; }
    get data() {
        if (!this._data)
            throw new CloudObjectNotLoaded();
        return this._data;
    }
}
exports.CloudObject = CloudObject;
//# sourceMappingURL=CloudObject.js.map